import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import './styles/App.css';
import {Header, Footer, ScrollToTop, TitleManager, RequireAuth} from './components/components_index';
import {
  Home, Calendar, Gallery, Directory, Reunions, MapPage, FamilyTree, 
  Person, Reunion, EditPerson, EditReunion, EditImg, Profile, UploadedPhotos, EditBio, EditReunionBio, EditAllPhotos} from './pages/pages_index';
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";

function App() {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <RequireAuth>
        <div className="App">
          <Router>
            <TitleManager />
            <ScrollToTop />
            <Header />
            <Body>
              <Routes>
                <Route path="/" element={<Home/>} />
                <Route path="/calendar" element={<Calendar/>} />
                <Route path="/gallery" element={<Gallery/>} />
                <Route path="/directory" element={<Directory/>} />
                <Route path="/reunions" element={<Reunions/>} />
                <Route path="/map" element={<MapPage/>} />
                <Route path="/family-tree" element={<FamilyTree/>} />
                <Route path="/people/:personID" element={<Person />} />
                <Route path="/reunion/:reunionID" element={<Reunion />} />
                <Route path="/edit-person" element={<EditPerson/>} />
                <Route path="/edit-reunion" element={<EditReunion/>} />
                <Route path="/edit-img" element={<EditImg/>} />
                <Route path="/profile" element={<Profile/>} />
                <Route path="/profile/:profileID" element={<Profile/>} />
                <Route path="/uploaded-photos" element={<UploadedPhotos/>} />
                <Route path="/edit-bio" element={<EditBio/>} />
                <Route path="/edit-bio/:bioID" element={<EditBio/>} />
                <Route path="/edit-reunion-bio/:reunionID" element={<EditReunionBio/>} />
                <Route path="/edit-photos" element={<EditAllPhotos/>} />
              </Routes>
            </Body>
            <Footer />
          </Router>
        </div>
      </RequireAuth>
    </QueryClientProvider>
  );
}

export default App;

function Body({children}) {
  return (
    <div className='App-page-body'>
      {children}
    </div>
  );
}

// git add .

// git commit -m "Message"

// git push